var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"play-report"},[_c('i',{staticClass:"fas fa-play"}),_c('i',{staticClass:"fas fa-file-alt system-text-color system-text-shadow"})])
}]

export { render, staticRenderFns }